import React from "react";

interface Props {
  tableHeaders: Array<string>;
  userCount: number;
}

const NUMERIC_HEADERS = ['Days Taken', 'Days Planned']

export const ReportTableHeaders = ({tableHeaders, userCount}: Props) => {
  return (
    <thead>
      <tr>
        <th className="report-members-header">{`Members(${userCount})`}</th>
        {tableHeaders.map((header, index) => (
          <th key={index} className={NUMERIC_HEADERS.includes(header) ? 'reports-table__num' : ''}>
            {header}
          </th>
        ))}
      </tr>
    </thead>
  )
}

